window.ProfilePageIntroductionElementProvider = {
	element: null,

	/**
	 * Fetch the "ProfilePageIntroduction" slide-in element.
	 *
	 * @returns {HTMLElement | undefined}
	 */

	getElement() {
		if (!this.element) {
			this.element = document.querySelector('.js-slideInElement[data-name="ProfilePageIntroduction"]');

			if (!this.element) {
				console.warn(
					'ProfilePageIntroductionElementProvider.getElement: ProfilePageIntroduction slide-in element not found.'
				);
				return;
			}
		}

		return this.element;
	}
};
